//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IMediaItem } from '@apis/media/mediaApiModels';
import { EmailBuilderDataActionType } from '@email-builder/actions/emailBuilderDataActions';
import { EMAIL_BUILDER_ACTIONS } from '@email-builder/constants/emailBuilderConstants';
import { IEmailBuilderData } from '@email-builder/models/emailBuilderStateModel';

const initialState: IEmailBuilderData = {
  afterCursor: undefined,
  allMediaItems: [] as IMediaItem[],
  dataSources: undefined,
  deletedCount: 0,
  fanreels: undefined,
  flags: {
    isRequestingDataSources: false,
    isRequestingMedia: false,
    isRequestingReels: false,
  },
  galleries: undefined,
  itemsInGalleryCount: 0,
  itemsMatchingFiltersCount: 0,
  mediaItems: [] as IMediaItem[],
  reelIdToDataSourceIdMap: undefined,
  staticHtml: undefined,
};

export default function EmailBuilderPanelReducer(
  state: IEmailBuilderData = initialState,
  action: EmailBuilderDataActionType,
): IEmailBuilderData {
  switch (action.type) {
    case EMAIL_BUILDER_ACTIONS.REQUEST_FANREELS: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingReels: true,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.RECEIVE_FANREELS_SUCCEEDED: {
      return {
        ...state,
        fanreels: action.fanreels,
        flags: {
          ...state.flags,
          isRequestingReels: false,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.RECEIVE_FANREELS_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingReels: false,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.REQUEST_GALLERIES: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingReels: true,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.RECEIVE_GALLERIES_SUCCEEDED: {
      return {
        ...state,
        galleries: action.galleries,
        flags: {
          ...state.flags,
          isRequestingReels: false,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.RECEIVE_GALLERIES_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingReels: false,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.REQUEST_DATA_SOURCES: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingDataSources: true,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.RECEIVE_DATA_SOURCES_SUCCEEDED: {
      return {
        ...state,
        dataSources: action.dataSources,
        flags: {
          ...state.flags,
          isRequestingDataSources: false,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.RECEIVE_DATA_SOURCES_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingDataSources: false,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_REEL_ID_TO_DATA_SOURCE_ID_MAP: {
      return {
        ...state,
        reelIdToDataSourceIdMap: action.reelIdToDataSourceIdMap,
      };
    }
    case EMAIL_BUILDER_ACTIONS.REQUEST_MEDIA_ITEMS: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingMedia: true,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.RECEIVE_MEDIA_ITEMS_SUCCEEDED: {
      return {
        ...state,
        mediaItems: [...state.mediaItems, ...action.mediaItems],
        flags: {
          ...state.flags,
          isRequestingMedia: false,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.RECEIVE_MEDIA_ITEMS_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingMedia: false,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_ITEMS_MATCHING_FILTERS_COUNT: {
      return {
        ...state,
        itemsMatchingFiltersCount: action.itemsMatchingFiltersCount,
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_ITEMS_IN_GALLERY_COUNT: {
      return {
        ...state,
        itemsInGalleryCount: action.itemsInGalleryCount,
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_AFTER_CURSOR: {
      return {
        ...state,
        afterCursor: action.afterCursor,
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_MEDIA_ITEMS: {
      return {
        ...state,
        mediaItems: action.mediaItems,
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_DELETED_COUNT: {
      return {
        ...state,
        deletedCount: action.deletedCount,
      };
    }
    case EMAIL_BUILDER_ACTIONS.RESET_MEDIA_DATA: {
      return {
        ...state,
        afterCursor: undefined,
        deletedCount: 0,
        mediaItems: [] as IMediaItem[],
        flags: {
          ...state.flags,
        },
        itemsMatchingFiltersCount: 0,
        allMediaItems: [] as IMediaItem[],
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_STATIC_HTML: {
      return {
        ...state,
        staticHtml: action.staticHtml,
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_ALL_MEDIA_ITEMS: {
      return {
        ...state,
        allMediaItems: action.allMediaItems,
      };
    }
    default:
      return state;
  }
}
